/**
 * VariationBadge — Mostra variação % ou absoluta com seta up/down
 */
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

interface VariationBadgeProps {
  value: number;
  tipo: "percentual" | "absoluto";
  suffix?: string;
}

export default function VariationBadge({ value, tipo, suffix }: VariationBadgeProps) {
  const isPositive = value > 0;
  const isNeutral = value === 0;
  const Icon = isPositive ? TrendingUp : isNeutral ? Minus : TrendingDown;
  const color = isPositive ? "text-green-600" : isNeutral ? "text-gray-400" : "text-red-600";
  const bg = isPositive ? "bg-green-50" : isNeutral ? "bg-gray-50" : "bg-red-50";
  const display = tipo === "percentual"
    ? `${isPositive ? "+" : ""}${value}%`
    : `${isPositive ? "+" : ""}${value}`;

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${color} ${bg}`}>
      <Icon size={12} />
      {display}{suffix ? ` ${suffix}` : ""}
    </span>
  );
}
